import { render, staticRenderFns } from "./switches.vue?vue&type=template&id=b5e7e0d8"
import script from "./switches.vue?vue&type=script&lang=js"
export * from "./switches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports